import script from "./CarouselComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarouselComponent.vue?vue&type=script&lang=ts&setup=true"

import "./CarouselComponent.vue?vue&type=style&index=0&id=67317303&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67317303"]])

export default __exports__